module.exports = __webpack_public_path__ + "static/section-4-e8a8c9575630a701abe7e95ac0f14a4d.svg";